import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import QueryPage from './pages/QueryPage';
import EmbeddedQueryPage from './pages/EmbeddedQueryPage';
import TenantUsagePage from './pages/TenantUsagePage';
import TenantUsageDetailPage from './pages/TenantUsageDetailPage';
import SettingsPage from './pages/SettingsPage';
import SchemaEditorPage from './pages/SchemaEditorPage';
import ChatHistoryPage from './pages/ChatHistoryPage';
import LoginPage from './pages/LoginPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isAuthLoading } = useAuth();

  if (isAuthLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/embed" element={<EmbeddedQueryPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/*" element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/query" element={<QueryPage />} />
                    <Route path="/usage" element={<TenantUsagePage />} />
                    <Route path="/usage/tenant/:tenantId" element={<TenantUsageDetailPage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                    <Route path="/schema" element={<SchemaEditorPage />} />
                    <Route path="/chat-history" element={<ChatHistoryPage />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            } />
          </Routes>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
